import React, { Fragment, useEffect, useState } from "react";
import { useDispatch, useSelector } from 'react-redux';
import { MENUITEMS } from "./SideMenu";
import { useLocation, Link, NavLink } from "react-router-dom";
import { Scrollbars } from "react-custom-scrollbars";
import { horizontalmenusticky } from "../../data/Switcherdata/Switcherdata";
import { meetingRoomPages } from '../../menu';
import LeftMenu from '../Menu/LeftMenu'
import { selectLeftmenu } from '../../store/actions2';
import { addSlash } from '../../utils';
// 导入 package.json 获取版本号
import packageJson from '../../../package.json';

let history: any = [];
const SideBar = () => {

  let location = useLocation();
  const [menuitems, setMenuitems] = useState<any>([]);

  const configData = useSelector((state: any) => state.configData||{});
  const web_show_sign = configData['web_show_sign']?configData['web_show_sign']:0;
  const [imgSrc, setImgSrc] = useState(configData["web_site_logo"]??"");
  const [imgSmailSrc, setImgSmailSrc] = useState(configData["web_site_logo_smail"]??"");

  const handleImageError = () => {
    setImgSrc(require("../../assets/img/brand/icon2.png")); // 加载失败时切换到默认图片
  };
  const handleImageSmailError = () => {
    setImgSmailSrc(require("../../assets/img/brand/logo1.png")); // 加载失败时切换到默认图片
  };
 
  useEffect(() => {
    if (menuitems.length > 0) {
      history.push(location.pathname); // add  history to history  stack for current location.pathname to prevent multiple history calls innerWidth  and innerWidth  calls from  multiple users. This is important because the history stack is not always empty when the user clicks  the history
      if (history.length > 2) {
        history.shift();
      }
      if (history[0] !== history[1]) {
        // console.log(location.pathname)
        setSidemenu();
      }
    }

    let mainContent = document.querySelector(".main-content");
    //when we click on the body to remove
    mainContent?.addEventListener("click", mainContentClickFn);
    return () => {
      mainContent?.removeEventListener("click", mainContentClickFn);
    };
  }, [location, mainContentClickFn, setSidemenu, menuitems]);
  // location
  useEffect(() => {
    // setSidemenu();
    if (
      document.body.classList.contains("horizontalmenu") &&
      window.innerWidth >= 992
    ) {
      clearMenuActive();
    }
  }, []);
  // every chnage this effect calls
  let menuIcontype = "";
  const body = document.querySelector("body")
  if (body?.classList.contains("horizontalmenu")) {
    menuIcontype = "hor-icon";
  } else {
    menuIcontype = "sidemenu-icon";
  }
  //  In Horizontal When we click the body it should we Closed
  // eslint-disable-next-line react-hooks/exhaustive-deps
  function mainContentClickFn() {
    if (
      document.body.classList.contains("horizontalmenu") &&
      window.innerWidth >= 992
    ) {
      clearMenuActive();
    }
  }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  function setSidemenu() {
    const pathname1 = addSlash(location.pathname)

    if (menuitems) {
      menuitems.filter((mainlevel: any) => {
        if (mainlevel.Items) {
          mainlevel.Items.filter((items: any) => {
            items.active = false;
            items.selected = false;
            if (pathname1 === "/spruha/preview/" || pathname1 === "/spruha/preview") {
              location.pathname = "/spruha/preview/dashboard/";
            }
            if (pathname1 === addSlash(items.path)) {
              items.active = true;
              items.selected = true;
            }
            if (items.children) {
              items.children.filter((submenu: any) => {
                submenu.active = false;
                submenu.selected = false;
                if (pathname1 === addSlash(submenu.path)) {
                  items.active = true;
                  items.selected = true;
                  submenu.active = true;
                  submenu.selected = true;
                }
                if (submenu.children) {
                  submenu.children.filter((submenu1: any) => {
                    submenu1.active = false;
                    submenu1.selected = false;
                    if (pathname1 === addSlash(submenu1.path)) {
                      items.active = true;
                      items.selected = true;
                      submenu.active = true;
                      submenu.selected = true;
                      submenu1.active = true;
                      submenu1.selected = true;
                    }
                    return submenu1;
                  });
                }
                return submenu;
              });
            }
            return items;
          });
        }
        setMenuitems((arr: any) => [...arr]);
        return mainlevel;
      });
    }
  }
  function toggleSidemenu(item: any) {
    if (
      !document.body.classList.contains("horizontalmenu-hover") ||
      window.innerWidth < 992
    ) {
      // To show/hide the menu
      if (!item.active) {
        menuitems.filter((mainlevel: any) => {
          if (mainlevel.Items) {
            mainlevel.Items.filter((sublevel: any) => {
              sublevel.active = false;
              if (item === sublevel) {
                sublevel.active = true;
              }
              if (sublevel.children) {
                sublevel.children.filter((sublevel1: any) => {
                  sublevel1.active = false;
                  if (item === sublevel1) {
                    sublevel.active = true;
                    sublevel1.active = true;
                  }
                  if (sublevel1.children) {
                    sublevel1.children.filter((sublevel2: any) => {
                      sublevel2.active = false;
                      if (item === sublevel2) {
                        sublevel.active = true;
                        sublevel1.active = true;
                        sublevel2.active = true;
                      }
                      return sublevel2;
                    });
                  }
                  return sublevel1;
                });
              }
              return sublevel;
            });
          }
          return mainlevel;
        });
      } else {
        item.active = !item.active;
      }
      setMenuitems((arr: any) => [...arr]);
    }
  }
  function clearMenuActive() {
    MENUITEMS.filter((mainlevel: any) => {
      mainlevel.filter((sublevel: any) => {
        sublevel.active = false;
        if (sublevel.children) {
          sublevel.children.filter((sublevel1: any) => {
            sublevel1.active = false;
            if (sublevel1.children) {
              sublevel1.children.filter((sublevel2: any) => {
                sublevel2.active = false;
                return sublevel2;
              });
            }
            return sublevel1;
          });
        }
        return sublevel;
      });

      return mainlevel;
    });
    setMenuitems((arr: any) => [...arr]);
  }

  // //Hover effect
  function Onhover() {
    const mainBody = document.querySelector(".main-body")
    if (mainBody) {
      if (
        mainBody.classList.contains("main-sidebar-hide")
      )
        mainBody.classList.add("main-sidebar-open");
    }
  }
  function Outhover() {
    const mainBody = document.querySelector(".main-body")
    if (mainBody) {
      mainBody.classList.remove("main-sidebar-open");
    }
  }



  const dispatch = useDispatch();
  const menuData = useSelector((state: any) => state.menuData);
  const [menuJson, setMenuJson] = useState<any>({})


  useEffect(() => {
    const obj1 = menuData.menuAll[menuData.topMenu]
    // console.log(obj1)

    if (obj1 && obj1.subMenu) {
      // if (obj1.id === 'inkScreenApplication') {
      //   setMenuJson(inkScreenPages)
      // } else {
      // }
      setMenuJson(obj1.subMenu)

      let arr1 = []
      const child = obj1.child
      for (let i = 0; i < child.length; i++) {
        const item1 = child[i]

        if (item1.child) {
          let item_arr1 = []
          for (let j = 0; j < item1.child.length; j++) {
            const item2 = item1.child[j]

            item_arr1.push({
              path: '/' + item2.name,
              icon: item2.css,
              title: item2.title,
              type: 'link',
              active: false,
              selected: false,
            })
          }

          arr1.push({
            title: item1.title,
            icon: item1.css,
            type: 'sub',
            active: false,
            selected: false,
            children: item_arr1
          })
        } else {
          arr1.push({
            path: '/' + item1.name,
            icon: item1.css,
            title: item1.title,
            type: 'link',
            active: false,
            selected: false,
          })
        }
      }

      const obj2 = {
        menutitle: '',
        Items: arr1
      }
      setMenuitems([obj2])

    } else {
      setMenuJson({})
      setMenuitems([])
    }
    // Object.keys().map((key: any) => (
    //     console.log(menuData.menuAll[key])
    // ))
  }, [menuData.topMenu, menuData.menuAll])

  // 点击菜单项触发状态改变
  function handleSelect(menu: any) {
    dispatch(selectLeftmenu(menu));
  }

  return (
    <Fragment>
      {/* <div
        className="sticky "
        style={{ marginBottom: "-64px" }}
        onScroll={horizontalmenusticky}
      > */}
      <div className="main-menu main-sidebar main-sidebar-sticky side-menu">
        <div className="main-container-1 active main-sidebar-header">
          <Scrollbars className="hor-scroll"
            style={{ position: "absolute" }}
          >
            <div className="sidemenu-logo">
              <Link
                className="main-logo"
                to={`${meetingRoomPages.dashboard.path}`}
              >
                {web_show_sign?<>
                 <img
                  src={imgSmailSrc}
                  className="header-brand-img desktop-logo"
                  alt={"logo1"}
                  onError={handleImageSmailError}
                />
                <img
                  src={imgSrc}
                  className="header-brand-img icon-logo"
                  alt={"logo-2"} style={{ width: '60%' }}
                  onError={handleImageError}
                />
                </>:""}
          

                {/* <img
                  src={require("../../assets/img/brand/logo.png")}
                  className="header-brand-img desktop-logo theme-logo"
                  alt={"logo-3"}
                />
                <img
                  src={require("../../assets/img/brand/icon.png")}
                  className="header-brand-img icon-logo theme-logo"
                  alt={"logo-4"} style={{ width: '60%' }}
                /> */}

              </Link>
            </div>
            <div
              className="main-body-1 main-sidebar-body"
              onMouseOver={() => Onhover()}
              onMouseOut={() => Outhover()}
            >
              <div className="slide-left " id="slide-left">
                <i className="fe fe-chevron-left"></i>
              </div>
              <ul className="menu-nav nav" style={{ marginLeft: "0px" }}>

                {/* <LeftMenu /> */}
                {/* {Object.keys(menuJson).map((key: any) => (
                  <li key={menuJson[key]["id"]} className={`nav-item ${menuData.leftMenu === menuJson[key]["id"] ? "active" : ""
                    }`} onClick={() => {
                      handleSelect(menuJson[key]["id"])
                    }}>
                    <NavLink
                      to={menuJson[key]["path"] + "/"}
                      className={`nav-link`}
                    >
                      <span className="shape1"></span>
                      <span className="shape2"></span>
                      <i
                        className={`${menuJson[key]["icon"]} ${menuIcontype} menu-icon`}
                      ></i>
                      <span className="sidemenu-label">
                        {menuJson[key]["text"]}
                      </span>
                    </NavLink>
                  </li>
                ))} */}


                {menuitems.map((Item: any, itemi: any) => (
                  <Fragment key={itemi + Math.random() * 100}>
                    <li className="nav-header">
                      <span className="nav-label">{Item.menutitle}</span>
                    </li>
                    {Item.Items.map((menuItem: any, i: any) => (
                      <li
                        className={`nav-item ${menuItem.selected ? "active" : ""
                          }`}
                        key={i}
                      >
                        {menuItem.type === "sub" ? (
                          <a
                            href="javascript"
                            className={`nav-link with-sub`}
                            onClick={(event) => {
                              event.preventDefault();
                              toggleSidemenu(menuItem);
                            }}
                          >
                            <span className="shape1"></span>
                            <span className="shape2"></span>
                            <i
                              className={`${menuItem.icon} ${menuIcontype} menu-icon`}
                            ></i>
                            <span className="sidemenu-label">
                              {menuItem.title}
                              {menuItem.active}
                            </span>
                            {menuItem.badge ? (
                              <label className={menuItem.badge}>
                                {menuItem.badgetxt}
                              </label>
                            ) : (
                              ""
                            )}
                            <div className="according-menu">
                              {menuItem.active ? (
                                <i
                                  className={`${menuItem.background} fa angle fa-angle-down `}
                                ></i>
                              ) : (
                                <i
                                  className={`${menuItem.background} fa angle fa-angle-right `}
                                ></i>
                              )}
                            </div>
                          </a>
                        ) : (
                          ""
                        )}

                        {menuItem.type === "link" ? (
                          <NavLink
                            to={menuItem.path}
                            className={`nav-link ${menuItem.selected ? " active" : ""
                              }`}
                          >
                            <span className="shape1"></span>
                            <span className="shape2"></span>
                            <i
                              className={`${menuItem.icon} ${menuIcontype} menu-icon`}
                            ></i>
                            <span className="sidemenu-label">
                              {menuItem.title}
                            </span>
                            {menuItem.badge ? (
                              <label className={menuItem.badge}>
                                {menuItem.badgetxt}
                              </label>
                            ) : (
                              ""
                            )}
                          </NavLink>
                        ) : (
                          ""
                        )}
                        {menuItem.children ? (
                          <ul
                            className={`nav-sub ${menuItem.active ? "open" : ""
                              }`}
                            style={
                              menuItem.active
                                ? { display: "block" }
                                : { display: "none" }
                            }
                          >
                            {menuItem.children.map((childrenItem: any, index: any) => {
                              return (
                                <li
                                  key={index}
                                  className={`nav-sub-item ${childrenItem.selected ? "active show" : ""
                                    }`}
                                >
                                  {childrenItem.type === "sub" ? (
                                    <a
                                      href="javascript"
                                      className="nav-sub-link sub-with-sub"
                                      onClick={(event) => {
                                        event.preventDefault();
                                        toggleSidemenu(childrenItem);
                                      }}
                                    >
                                      <span className="sidemenu-label">
                                        {childrenItem.title}
                                        {childrenItem.active}
                                      </span>
                                      {childrenItem.active ? (
                                        <i className="angle fa fa-angle-down"></i>
                                      ) : (
                                        <i
                                          className={`${menuItem.background} fa angle fa-angle-right `}
                                        ></i>
                                      )}
                                    </a>
                                  ) : (
                                    ""
                                  )}

                                  {childrenItem.type === "link" ? (
                                    <NavLink
                                      to={childrenItem.path}
                                      className="nav-sub-link"
                                    >
                                      {childrenItem.title}
                                    </NavLink>
                                  ) : (
                                    ""
                                  )}
                                  {childrenItem.children ? (
                                    <ul
                                      className="sub-nav-sub"
                                      style={
                                        childrenItem.active
                                          ? { display: "block" }
                                          : { display: "none" }
                                      }
                                    >
                                      {childrenItem.children.map(
                                        (childrenSubItem: any, key: any) => (
                                          <li
                                            className={`nav-sub-item ${childrenSubItem.selected
                                              ? " active"
                                              : ""
                                              }`}
                                            key={key}
                                          >
                                            {childrenSubItem.type ===
                                              "link" ? (
                                              <NavLink
                                                to={
                                                  childrenSubItem.path
                                                }
                                                className="nav-sub-link"
                                              >
                                                {childrenSubItem.title}
                                              </NavLink>
                                            ) : (
                                              ""
                                            )}

                                            {childrenSubItem.type ===
                                              "sub" ? (
                                              <Link
                                                to="#"
                                                className="nav-sub-item"
                                                onClick={(event) => {
                                                  event.preventDefault();
                                                  toggleSidemenu(
                                                    childrenSubItem
                                                  );
                                                }}
                                              >
                                                <span className="sidemenu-label">
                                                  {childrenSubItem.title}
                                                </span>
                                                {childrenSubItem.active ? (
                                                  <i className="fa fa-angle-down"></i>
                                                ) : (
                                                  <i className="fa fa-angle-right"></i>
                                                )}
                                              </Link>
                                            ) : (
                                              ""
                                            )}
                                          </li>
                                        )
                                      )}
                                    </ul>
                                  ) : (
                                    ""
                                  )}
                                </li>
                              );
                            })}
                          </ul>
                        ) : (
                          ""
                        )}
                      </li>
                    ))}
                  </Fragment>
                ))}
              </ul>
              <div className="slide-right" id="slide-right">
                <i className="fe fe-chevron-right"></i>
              </div>
              {/* 版本号显示 */}
              <div style={{
                position: 'absolute',
                bottom: '10px',
                left: '50%',
                transform: 'translateX(-50%)',
                fontSize: '11px',
                color: '#999',
                userSelect: 'none',
                whiteSpace: 'nowrap',
                textAlign: 'center',
                width: '100%',
                padding: '0 10px'
              }}>
                v{packageJson.version}
              </div>
            </div>
          </Scrollbars>
        </div>
      </div>
      {/* </div> */}
      {/* <div className="jumps-prevent" style={{ paddingTop: "64px" }}></div> */}
    </Fragment>
  );
};

export default SideBar;
